import { useEffect, useRef, useState } from "react";
import { fetchVenueAvailabilityAsync } from "../../../../redux/leads/leadsActions";
import { IBooking } from "../../../../redux/booking/booking.types";
import { IMultipleEvent } from "../../../../redux/leads/leads.types";
import { useDispatchWrapper } from "../../../../hooks";
import { hasAvailabilityInputs, isAvailabilityRelevantStatus } from "../../helpers/leadHelpers";

type VenueAvailabilityState = {
  checked: boolean;
  availabilty: boolean | null;
  details: IBooking | null;
};

const FIELDS_TO_CHECK: (keyof IMultipleEvent)[] = [
  "function_date",
  "preferred_venue_uuid",
  "preferred_venue",
  "event_time_uuid",
  "event_time",
];

export const useEventChangeDetector = (
  data: IMultipleEvent | null,      // original
  values: IMultipleEvent | null     // form values
): VenueAvailabilityState => {
  const dispatch = useDispatchWrapper();

  const lastTriggeredRef = useRef<string | null>(null);

  const [state, setState] = useState<VenueAvailabilityState>({
    checked: false,
    availabilty: null,
    details: null,
  });

  useEffect(() => {
    if (!data || !values) return;

    // =============================
    // 1. DETECT CHANGE
    // =============================
    const hasChange = FIELDS_TO_CHECK.some((field) => {
      return (data[field] ?? null) !== (values[field] ?? null);
    });

console.log("values hasChange===> ", hasChange)

    if (!hasChange) return;
    // =============================
    // 2. VALIDATION GUARDS
    // =============================
    if (!isAvailabilityRelevantStatus(values.status)) return;
    if (!hasAvailabilityInputs(values)) return;

    // =============================
    // 3. PREVENT DUPLICATE API CALLS
    // =============================
    const uniqueKey = `${values.preferred_venue_uuid}-${values.event_time_uuid}-${values.function_date}`;

    if (lastTriggeredRef.current === uniqueKey) return;

    lastTriggeredRef.current = uniqueKey;

    // =============================
    // 4. API CALL
    // =============================
    dispatch(
      fetchVenueAvailabilityAsync(
        values.preferred_venue_uuid,
        values.event_time_uuid,
        values.function_date as string,
        (isSuccess: boolean, data: any) => {
          setState({
            checked: true,
            availabilty: data?.availabilty ?? null,
            details: data ?? null,
          });
        }
      )
    );
  }, [data, values, dispatch]);

  return state;
};